import React from "react";

import step1 from "../../static/images/landingpage/tutorial/cho_thue_xe_co_taigia_re_tphcm.svg";
import step2 from "../../static/images/landingpage/tutorial/gia_thue_xe_7cho_tai_tphcm.svg";
import step3 from "../../static/images/landingpage/tutorial/gia_thue_xe_7cho_tai_hanoi.svg";
import step4 from "../../static/images/landingpage/tutorial/gia_thue_xe_4cho_tai_tphcm.svg";

const TUTORIALS = [
	{
		id: "01",
		img: step1,
		alt: "cho_thue_xe_co_taigia_re_tphcm",
		title: "Đặt xe trên<br />app/web Mioto",
	},
	{
		id: "02",
		img: step2,
		alt: "gia_thue_xe_7cho_tai_tphcm",
		title: "Nhận xe",
	},
	{
		id: "03",
		img: step3,
		alt: "gia_thue_xe_7cho_tai_hanoi",
		title: "Bắt đầu<br />hành trình",
	},
	{
		id: "04",
		img: step4,
		alt: "gia_thue_xe_4cho_tai_tphcm",
		title: "Trả xe & kết thúc<br />chuyến đi",
	},
];

const TutorialItem = ({ item }) => (
	<div className="tutorial-item">
		<div className="tutorial-item__img">
			<img loading="lazy" src={item.img} alt={item.alt} />
		</div>
		<div className="tutorial-item__content">
			<h5 className="text-primary">{item.id}</h5>
			<h5 dangerouslySetInnerHTML={{ __html: item.title }} />
		</div>
	</div>
);

const Tutorial = () => {
	return (
		<div className="tutorial-section space sec">
			<div className="m-container">
				<h2>Hướng Dẫn Thuê Xe </h2>
				<h5 className="title">Chỉ với 4 bước đơn giản để trải nghiệm thuê xe Mioto một cách nhanh&nbsp;chóng</h5>
				<div className="tutorial-container">
					{TUTORIALS.map((tutorial) => (
						<TutorialItem key={tutorial.id} item={tutorial} />
					))}
				</div>
			</div>
		</div>
	);
};

export default Tutorial;
